import * as React from "react";
import { IconProps } from "../types";

const CircleQuestionOutlineIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        width="18"
        height="18"
        fill="none"
        viewBox="0 0 18 18"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M9 16.25C13.0041 16.25 16.25 13.0041 16.25 9C16.25 4.99594 13.0041 1.75 9 1.75C4.99594 1.75 1.75 4.99594 1.75 9C1.75 13.0041 4.99594 16.25 9 16.25Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.925 6.61895C7.313 5.56195 8.219 5.12695 9.105 5.12695C10 5.12695 10.923 5.76495 10.923 6.93495C10.923 8.71895 9.107 8.40295 8.827 9.99995"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.791 13.5669C8.239 13.5669 7.791 13.1179 7.791 12.5669C7.791 12.0159 8.239 11.5669 8.791 11.5669C9.343 11.5669 9.791 12.0159 9.791 12.5669C9.791 13.1179 9.343 13.5669 8.791 13.5669Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default CircleQuestionOutlineIcon;
